import 'bootstrap/dist/css/bootstrap.css';
import { cnpj as cnpjValidacao } from 'cpf-cnpj-validator';
import { ChangeEvent, useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EnderecoDTO } from '../../../shared/dto/enderecoDTO';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';
import { Matriz } from '../../../shared/model/matriz'; //
import { Originador } from '../../../shared/model/originador'; //
import Spinner from '../../../shared/spinner';
import { Button, Row, Col, Form } from 'react-bootstrap'; 
import MatrizService from '../../../services/matrizService'; //
import PromotoraService from '../../../services/promotoraService'; //
import ViaCepService from '../../../services/viaCepService';
import OriginadorService from '../../../services/originadorService'; //
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { NumericFormat } from 'react-number-format';
import { Regional } from '../../../shared/model/regional'; 
import { Comercial } from '../../../shared/model/comercial'; 
import RegionalService from '../../../services/regionalService';
import ComercialService from '../../../services/comercialService';
import DualListBox from '../../../shared/DualListBox';

interface ListItem {
  id: number | string;
  nome: string;
}

function PromotoraInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const { tipo, slug } = useParams();

  const [regionais, setRegionais] = useState<Regional[]>([]); 
  const [selectedRegionais, setSelectedRegionais] = useState<ListItem[]>([]); 
  //const isInitialMount = useRef(true);
  const [comerciais, setComerciais] = useState<Comercial[]>([]); 
  const [selectedComerciais, setSelectedComerciais] = useState<ListItem[]>([]); 
  const [showRegionalBox, setShowRegionalBox] = useState(false);
  const [showComercialBox, setShowComercialBox] = useState(false);
  const [matriz, setMatriz] = useState('');
  const [matrizes, setMatrizes] = useState<Matriz[]>([]);

  // --- Originador como secundário ---
  const [originadoresSelecionados, setOriginadoresSelecionados] = useState<string[]>([]);
  const [originadores, setOriginadores] = useState<Originador[]>([]);
  const [showOriginadorBox, setShowOriginadorBox] = useState(false); // Checkbox para habilitar originador

  const [nome, setNome] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [emails, setEmails] = useState('');
  const [telefoneComercial, setTelefoneComercial] = useState('');
  const [telefoneCelular, setTelefoneCelular] = useState('');
  const [gerenteResponsavel, setGerenteResponsavel] = useState('');
  const [valorMeta, setValorMeta] = useState<number | string>(0);
  const [numeroMaximoConsultasDia, setNumeroMaximoConsultasDia] = useState<number | string>(0);

  // Endereço
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [localidade, setLocalidade] = useState('');
  const [uf, setUf] = useState('');

  // Configurações
  const [codigoExterno, setCodigoExterno] = useState('');
  const [promotoraAquisicao, setPromotoraAquisicao] = useState(false);

  // DADOS BANCÁRIOS (Necessários para CNAB 240) ---
  const [codigoBanco, setCodigoBanco] = useState(''); // Separado do nome
  const [nomeBanco, setNomeBanco] = useState('');     // Separado do código
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [digitoConta, setDigitoConta] = useState('');
  const [tipoConta, setTipoConta] = useState('CORRENTE'); // Default
  const [camaraCentralizadora, setCamaraCentralizadora] = useState('018'); // Default TED (STR)
  const [chavePix, setChavePix] = useState('');

  const [loading, setLoading] = useState(false);

  const matrizService: MatrizService = new MatrizService();
  const promotoraService: PromotoraService = new PromotoraService();
  const viaCepService: ViaCepService = new ViaCepService();
  const originadorService: OriginadorService = new OriginadorService();

    // Dicionário de explicações para formas de pagamento
  const explicacoesPagamento: { [key: string]: string } = {
    '018': 'TED (STR): Transferência Eletrônica Disponível convencional. Utilize para contas de bancos diferentes. O crédito geralmente ocorre no mesmo dia se enviado até o horário de corte (17h).',
    '000': 'Mesmo Banco (CC): Crédito em Conta Corrente. Utilize SOMENTE quando o banco de origem (pagador) for o mesmo do banco de destino (favorecido). Processamento mais rápido e sem custos de TED.',
    '009': 'PIX: Pagamento Instantâneo. Informe a Chave PIX somente quando quiser cadastrar esses dados bancários. Disponível 24/7.',
    '888': 'TED (CIP): Modalidade específica de TED via Câmara Interbancária de Pagamentos (menos comum que o STR 018).'
  };

  // Carrega originadores quando a matriz muda
  const carregarOriginadores = async (matrizId: string) => {
      if(!matrizId) {
        setOriginadores([]);
        return;
      }
      try {
          // Busca originadores vinculados à matriz selecionada
          const response = await originadorService.listarPorMatriz(matrizId); // Assumindo que existe esse método no service
          setOriginadores(response.data);
      } catch (err) {
          console.error("Erro ao carregar originadores:", err);
          // Não trava a tela se der erro, só loga
      }
  };

  const handleMatrizChange = (e: ChangeEvent<HTMLSelectElement>) => {
      const novaMatriz = e.target.value;
      setMatriz(novaMatriz);
      setOriginadoresSelecionados([]); // Limpa originadores ao trocar matriz
      if(showOriginadorBox){
          carregarOriginadores(novaMatriz);
      }
  };

  const handleOriginadorChange = (e: ChangeEvent<HTMLSelectElement>) => {
      const selecionados = Array.from(e.target.selectedOptions).map((option) => option.value);
      setOriginadoresSelecionados(selecionados);
  };

  const handleCheckboxOriginador = (e: ChangeEvent<HTMLInputElement>) => {
      const isChecked = e.target.checked;
      setShowOriginadorBox(isChecked);
      if (isChecked && matriz) {
          carregarOriginadores(matriz);
      } else {
          setOriginadoresSelecionados([]);
          setOriginadores([]);
      }
  }

  const extrairIdsOriginadores = (jsonPromotora: any): string[] => {
    const ids = new Set<string>();

    if (Array.isArray(jsonPromotora.idsOriginadores)) {
      jsonPromotora.idsOriginadores
        .filter((idOriginador: any) => idOriginador !== null && idOriginador !== undefined)
        .forEach((idOriginador: any) => ids.add(idOriginador.toString()));
    }

    if (Array.isArray(jsonPromotora.originadores)) {
      jsonPromotora.originadores
        .map((originadorItem: any) => originadorItem?.id)
        .filter((idOriginador: any) => idOriginador !== null && idOriginador !== undefined)
        .forEach((idOriginador: any) => ids.add(idOriginador.toString()));
    }

    if (jsonPromotora.idOriginador) {
      ids.add(jsonPromotora.idOriginador.toString());
    }

    return Array.from(ids);
  };

  const listarPromotoraPorId = async () => {
    try {
      setLoading(true);
      const response = await promotoraService.listarPromotoraPorId(id);
      const jsonPromotora = response.data; 

      setMatriz(jsonPromotora.idMatriz ? jsonPromotora.idMatriz.toString() : '');
      
      // Carrega originadores se tiver matriz
      if (jsonPromotora.idMatriz) {
          await carregarOriginadores(jsonPromotora.idMatriz.toString());
      }

      const idsOriginadores = extrairIdsOriginadores(jsonPromotora);
      if (idsOriginadores.length > 0) {
          setShowOriginadorBox(true);
          setOriginadoresSelecionados(idsOriginadores);
      }

      setNome(jsonPromotora.nome);
      setCnpj(jsonPromotora.cnpj);
      setEmails(jsonPromotora.email);
      setTelefoneComercial(jsonPromotora.foneComercial);
      setTelefoneCelular(jsonPromotora.foneCelular);
      setGerenteResponsavel(jsonPromotora.gerenteResponsavel);
      setValorMeta(jsonPromotora.valorMeta);
      setNumeroMaximoConsultasDia(jsonPromotora.nconsultas ?? 0);
      setCodigoExterno(jsonPromotora.codigoExterno);
      setPromotoraAquisicao(jsonPromotora.promotoraAquisicao ?? false);

      // Endereço
      setCep(jsonPromotora.cep || jsonPromotora.enderecoDTO?.cep || '');
      setLogradouro(jsonPromotora.endereco || jsonPromotora.enderecoDTO?.logradouro || '');
      setNumero(jsonPromotora.numeroEndereco || jsonPromotora.enderecoDTO?.numero || '');
      setComplemento(jsonPromotora.complemento || jsonPromotora.enderecoDTO?.complemento || '');
      setBairro(jsonPromotora.bairro || jsonPromotora.enderecoDTO?.bairro || '');
      setLocalidade(jsonPromotora.cidade || jsonPromotora.enderecoDTO?.localidade || '');
      setUf(jsonPromotora.uf || jsonPromotora.enderecoDTO?.uf || '');
      setCodigoExterno(jsonPromotora.codigoExterno);
      setPromotoraAquisicao(jsonPromotora.promotoraAquisicao ?? false);

      // Dados Bancários
      setCodigoBanco(jsonPromotora.codigoBanco || '');
      setNomeBanco(jsonPromotora.nomeBanco || '');
      setAgencia(jsonPromotora.agencia || '');
      setConta(jsonPromotora.conta || '');
      setDigitoConta(jsonPromotora.digitoConta || '');
      setTipoConta(jsonPromotora.tipoConta || 'CORRENTE');
      setCamaraCentralizadora(jsonPromotora.camaraCentralizadora || '018');
      setChavePix(jsonPromotora.chavePix || '');

    } catch (err) {
      console.error(err);
      setAlert({ message: "Erro ao carregar dados da promotora.", type: 'error' });
    }
    setLoading(false);
  };

  const limparCampos = () => {
    setMatriz('');
    setOriginadoresSelecionados([]);
    setShowOriginadorBox(false);
    setOriginadores([]);
    setNome('');
    setCnpj('');
    setEmails('');
    setTelefoneComercial('');
    setTelefoneCelular('');
    setGerenteResponsavel('');
    setValorMeta(0);
    setCep('');
    setLogradouro('');
    setNumero('');
    setComplemento('');
    setBairro('');
    setLocalidade('');
    setNumeroMaximoConsultasDia(0);
    setUf('');
    setCodigoExterno('');
    setPromotoraAquisicao(false);
    
    // Limpar Bancários
    setCodigoBanco('');
    setNomeBanco('');
    setAgencia('');
    setConta('');
    setDigitoConta('');
    setTipoConta('CORRENTE');
    setCamaraCentralizadora('018');
    setChavePix('');

    setSelectedRegionais([]); 
    setSelectedComerciais([]);
    setShowRegionalBox(false);
    setShowComercialBox(false);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault(); 
    
    if (!cnpjValidacao.isValid(cnpj)) {
      setAlert({ message: 'CNPJ inválido', type: 'warning' });
      return;
    } 
    
    setLoading(true);
    let endereco: EnderecoDTO = new EnderecoDTO();
    endereco.cep = cep;
    endereco.logradouro = logradouro;
    endereco.numero = numero;
    endereco.complemento = complemento;
    endereco.bairro = bairro;
    endereco.uf = uf;
    endereco.localidade = localidade;

    let promotora: PromotoraDTO = new PromotoraDTO();
    promotora.matriz = matriz; // Volta a enviar a Matriz
    promotora.id = id!;
    promotora.nome = nome;
    promotora.cnpj = cnpj;
    promotora.email = emails;
    promotora.enderecoDTO = endereco;
    promotora.telefoneComercial = telefoneComercial;
    promotora.telefoneCelular = telefoneCelular;
    promotora.gerenteResponsavel = gerenteResponsavel;
    promotora.valorMeta = valorMeta;
    promotora.codigoExterno = codigoExterno;
    promotora.nConsultas = numeroMaximoConsultasDia;
    promotora.promotoraAquisicao = promotoraAquisicao;

    const idsOriginadoresSelecionados = originadoresSelecionados
      .map((idOriginador) => Number(idOriginador))
      .filter((idOriginador) => !Number.isNaN(idOriginador));

    // Envia os originadores se estiver habilitado e selecionado
    if (showOriginadorBox && idsOriginadoresSelecionados.length > 0) {
        promotora.idsOriginadores = idsOriginadoresSelecionados;
        promotora.idOriginador = idsOriginadoresSelecionados[0];
    } else {
        promotora.idsOriginadores = [];
        promotora.idOriginador = null;
    }

    const temDadosBancarios = [
      codigoBanco,
      nomeBanco,
      agencia,
      conta,
      digitoConta,
      chavePix
    ].some(valor => valor.trim() !== '');

    // Preenchendo Dados Bancários somente quando informados
    promotora.codigoBanco = temDadosBancarios ? codigoBanco : '';
    promotora.nomeBanco = temDadosBancarios ? nomeBanco : '';
    promotora.agencia = temDadosBancarios ? agencia : '';
    promotora.conta = temDadosBancarios ? conta : '';
    promotora.digitoConta = temDadosBancarios ? digitoConta : '';
    promotora.tipoConta = temDadosBancarios ? tipoConta : '';
    promotora.camaraCentralizadora = temDadosBancarios ? camaraCentralizadora : '';
    promotora.chavePix = temDadosBancarios ? chavePix : '';

    console.log("Enviando para o backend:", promotora);

    try {
      const response = await promotoraService.incluirAlterarPromotora(promotora);
      const promotoraSalva = response.data;
      setLoading(false);

      if (tipo === 'inclusao') {
        const desejaCadastrarUsuario = window.confirm(
          'Promotora salva com sucesso!\n\nVocê deseja cadastrar um usuário para essa promotora?'
        );

        if (desejaCadastrarUsuario) {
          if (!promotoraSalva?.id) {
            setAlert({
              message: 'Promotora salva, mas não foi possível identificar o código para abrir o cadastro de usuário.',
              type: 'warning'
            });
            return;
          }

          navigate(slug ? `/${slug}/sistema-usuario/inclusao` : '/sistema-usuario/inclusao', {
            state: {
              cadastroUsuarioPromotora: {
                promotoraId: promotoraSalva.id,
                promotoraNome: promotoraSalva.nome || nome
              }
            }
          });
          return;
        }
      }

      setAlert({ message: 'Promotora salva com sucesso!', type: 'success' });
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || 'Erro ao salvar promotora.', type: 'error' });
      console.error(err);
    }
  };

  const handleNumeroMaximoConsultasChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const valor = e.target.value.replace(/\D/g, '');
    setNumeroMaximoConsultasDia(valor);
  };

  const viaCep = async (cep: string) => {
    if (cep !== undefined && cep !== '' && cep.length === 10) {
      setLoading(true);
      const cepWithoutMask = cep.replace(/\D/g, '');
      try {
        const response = await viaCepService.viaCep(cepWithoutMask);
        const jsonViaCep = response.data;
        setLogradouro(jsonViaCep.logradouro);
        setLocalidade(jsonViaCep.localidade);
        setUf(jsonViaCep.uf);
        setBairro(jsonViaCep.bairro);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const carregarListas = async () => {
      setLoading(true);
      try {
        const matrizRes = await matrizService.listarTodasMatrizesAtivas();

        if (matrizRes.data) {
          setMatrizes(matrizRes.data);
          if (tipo === 'inclusao' && matrizRes.data.length > 0) {
            setMatriz(matrizRes.data[0].id!.toString());
          }
        }
        
      } catch (err) {
        console.error("Erro ao carregar lista de matrizes:", err);
        setAlert({ message: "Erro ao carregar lista de matrizes.", type: 'error' });
      } finally {
        if (tipo !== 'alteracao') {
          setLoading(false);
        }
      }
    };

    carregarListas();

    if (tipo === 'alteracao' && id) {
      listarPromotoraPorId(); 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo, id]);


  return (
    <div className="container">
      {alert && (
        <CustomAlert
          message={alert.message}
          type={alert.type}
          onClose={() => {
            setAlert(null);
            if (alert.type === 'success') {
              window.history.back();
            }
          }}
        />
      )}

      {loading ? (
        <Spinner loading={loading} />
      ) : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              <h5>
                Origens &gt; Promotora &gt; {tipo === 'inclusao' ? 'Inclusão' : 'Alteração'}
              </h5>
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>

          <div className="row">
            <div className="col-md">
              <label>Matriz <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" value={matriz} onChange={handleMatrizChange} required>
                {matrizes.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md">
              <label>Gerente Responsável</label>
              <input type="text" className="form-control" value={gerenteResponsavel} onChange={(e) => setGerenteResponsavel(e.target.value)} />
            </div>
          </div>

          <hr className="my-4" />
          <h5 className="mb-3">Vínculo {Originador.DESCRITIVO_GERAL}</h5>
          <Row className="mb-3">
            <Col md={12}>
                <Form.Check
                    type="checkbox"
                    id="originadorCheckbox"
                    label={`Vincular a uma ou mais ${Originador.DESCRITIVO_GERAL}`}
                    checked={showOriginadorBox}
                    onChange={handleCheckboxOriginador}
                />
            </Col>
          </Row>

          {showOriginadorBox && (
              <Row className="mb-3">
                  <div className="col-md">
                    <label>{Originador.DESCRITIVO_GERAL}</label>
                    <select
                      className="form-select"
                      multiple
                      size={Math.min(Math.max(originadores.length, 3), 8)}
                      value={originadoresSelecionados}
                      onChange={handleOriginadorChange}
                    >
                        {originadores.map((item) => (
                        <option key={item.id} value={item.id!}>
                            {item.id + ' - ' + item.nome}
                        </option>
                        ))}
                    </select>
                    {originadores.length === 0 && matriz && (
                        <small className="text-muted">Nenhum originador encontrado para esta Matriz.</small>
                    )}
                  </div>
              </Row>
          )}

          <div className="row mt-3">
            <div className="col-xl">
              <label>Razão Social <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>CNPJ <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="99.999.999/9999-99" type="text" className="form-control" value={cnpj} onChange={(e) => setCnpj(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xl">
              <label>Lista de E-mails (separados por ';')<span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={emails} onChange={(e) => setEmails(e.target.value)} />
            </div>
          </div>

          <hr className="my-4" />
          <h5 className="mb-3">Dados Bancários</h5>
          
          <div className="row">
            <div className="col-md-2">
              <label>Cód. Banco</label>
              <input type="text" className="form-control" placeholder="341" maxLength={3}
                value={codigoBanco} onChange={e => setCodigoBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-4">
              <label>Nome do Banco</label>
              <input type="text" className="form-control" placeholder="Itaú Unibanco" 
                value={nomeBanco} onChange={e => setNomeBanco(e.target.value)} 
              />
            </div>
            <div className="col-md-2">
              <label>Agência (sem dígito)</label>
              <input type="text" className="form-control" maxLength={5}
                value={agencia} onChange={e => setAgencia(e.target.value)} 
              />
            </div>
            <div className="col-md-3">
              <label>Conta Corrente</label>
              <input type="text" className="form-control" maxLength={15}
                value={conta} onChange={e => setConta(e.target.value)} 
              />
            </div>
            <div className="col-md-1">
              <label>Dígito</label>
              <input type="text" className="form-control" maxLength={2}
                value={digitoConta} onChange={e => setDigitoConta(e.target.value)} 
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-2">
              <label>Tipo Conta</label>
              <select className="form-select" value={tipoConta} onChange={e => setTipoConta(e.target.value)}>
                <option value="CORRENTE">Corrente</option>
                <option value="POUPANCA">Poupança</option>
              </select>
            </div>
            <div className="col-md-4">
              <label>Forma de Pagamento</label>
              <select className="form-select" value={camaraCentralizadora} onChange={e => setCamaraCentralizadora(e.target.value)}>
                <option value="018">TED (STR)</option>
                <option value="000">Mesmo Banco (CC)</option>
                <option value="009">PIX</option>
                <option value="888">TED (CIP)</option>
              </select>
            </div>
            {camaraCentralizadora === '009' && (
              <div className="col-md-6">
                <label>Chave PIX</label>
                <input type="text" className="form-control" placeholder="Email, CPF/CNPJ, Celular ou Chave Aleatória"
                  value={chavePix} onChange={e => setChavePix(e.target.value)} 
                />
              </div>
            )}
          </div>
          
          <div className="row mt-2">
            <div className="col-12">
              <div className="alert alert-info py-2 small mb-0">
                <strong><i className="bi bi-info-circle-fill me-2"></i>Informação:</strong> {explicacoesPagamento[camaraCentralizadora]}
              </div>
            </div>
          </div>

          <hr className="my-4" />


          <div className="row">
            <div className="col-md-2">
              <label>CEP</label>
              <InputMask mask="99.999-999" type="text" className="form-control"
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                onBlur={(e) => viaCep(e.target.value)}
              />
            </div>
            <div className="col-md">
              <label>Endereço</label>
              <input type="text" className="form-control" value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
            </div>
            <div className="col-md-3">
              <label>Número</label>
              <input type="number" className="form-control" value={numero} onChange={(e) => setNumero(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md">
              <label>Bairro</label>
              <input type="text" className="form-control" value={bairro} onChange={(e) => setBairro(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Complemento</label>
              <input type="text" className="form-control" value={complemento} onChange={(e) => setComplemento(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Cidade</label>
              <input type="text" className="form-control" value={localidade} onChange={(e) => setLocalidade(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Estado</label>
              <InputMask mask="aa" type="text" className="form-control" value={uf} onChange={(e) => setUf(e.target.value.toUpperCase())} />
            </div>
          </div>

          <hr className="my-4" />

          <div className="row">
            <div className="col-md">
              <label>Telefone Comercial <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="(99)9999-9999" type="text" className="form-control" value={telefoneComercial} onChange={(e) => setTelefoneComercial(e.target.value)} />
            </div>
            <div className="col-md">
              <label>Telefone Celular <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="(99)99999-9999" type="text" className="form-control" value={telefoneCelular} onChange={(e) => setTelefoneCelular(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md">
              <label>Valor Meta <span style={{ color: 'red' }}>*</span></label>
              <NumericFormat
                className="form-control"
                required
                thousandSeparator="."
                decimalSeparator=","
                prefix="R$ "
                value={valorMeta}
                onValueChange={(values) => setValorMeta(values.value)}
              />
            </div>

            <div className="col-md">
              <label>Número Máximo de Consultas Margem por Dia <span style={{ color: 'red' }}>*</span></label>
              <input type="number" required className="form-control" value={numeroMaximoConsultasDia} onChange={handleNumeroMaximoConsultasChange} />
            </div>
          </div>

          <hr className="my-4" />
          
          <div className="row">
            <div className="col-md">
              <label>Código Externo</label>
              <input type="text" className="form-control" value={codigoExterno} onChange={(e) => setCodigoExterno(e.target.value)} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="promotoraAquisicao"
                  checked={promotoraAquisicao}
                  onChange={(e) => setPromotoraAquisicao(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="promotoraAquisicao">
                  Promotora Aquisição
                </label>
              </div>
            </div>
          </div>

          <hr className="my-4" />

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal">Limpar Campos</button>
            <button className="w-40 btn btn-success btn-lg" type="submit">
              {tipo !== 'inclusao' ? 'Alterar Promotora' : 'Salvar Promotora'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default PromotoraInclusaoAlteracao;
